import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import ComparisonSection from './components/ComparisonSection';
import FeaturesSection from './components/FeaturesSection';
import ApprovalSection from './components/ApprovalSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <ProductsSection />
        <ComparisonSection />
        <FeaturesSection />
        <ApprovalSection />
        <FAQSection />
        <div className="py-8 md:py-12 bg-white">
          <CTASection />
        </div>
      </main>
      <Footer />
    </div>
  );
}